import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import ActionButtonDropdown from "../../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../../Core/Layout/ListLayout";
import Tabs from "../../../../../Components/Tabs";
import ConfigureColumns from "./ConfigureColumns";
import ReportTable from "../../../../../Core/ReportTable/ReportTable";
import ReportSearchFilter from "../../../../../Core/ReportSearchFilter/ReportSearchFilter"
import { useGetFrappeReportQuery, useGetDocTypeResourceQuery, useGetDynamicResourceQuery } from '../../../../../store/api/reportApi';
import { useGetCompanyQuery } from '../../../../../store/api/companyapi'
import ApiResponseBox from "../../../../../Components/ApiResponseBox";
import { usePostItemListMutation } from "../../../../../store/api/purchaseorderapi";
const Lpntable = () => {
    const navigate = useNavigate();
    const pageSize = 11;
    const [currentPage, setCurrentPage] = useState(1);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [errorr, setError] = useState('');
    const [ptype, setptype] = useState("Error");
    const [showError, setShowError] = useState(false);
    const [tableFooter, setTableFooter] = useState(null);
    const [itemGroupSearchTerm, setItemGroupSearchTerm] = useState('');
    const [supplierSearchTerm, setsupplierSearchTerm] = useState('');
    const [triger, settriger] = useState(false);



    const [item_list, setitem_list] = useState([]);
    const [getitem_list_data] = usePostItemListMutation();
    const {
        data: companyData,
        error: companyError,
        isLoading: companyLoading,
        refetch: companyRefetch
    } = useGetCompanyQuery();
    const {
        data: itemGroupsData,
        isLoading: itemGroupsLoading,
    } = useGetDynamicResourceQuery({
        resource: "Item Group",
        searchTerm: itemGroupSearchTerm,
        fields: ["name"]
    });

    const {
        data: suppliersData,
        isLoading: suppliersLoading,
    } = useGetDynamicResourceQuery({
        resource: "Supplier",
        searchTerm: supplierSearchTerm,
        fields: ["name"]
    });


    const companyOptions = companyData?.result?.map(company => ({
        value: company.name,
        label: company.company_name || company.name,
    })) || [];

    const itemGroupOptions = itemGroupsData?.data?.map(group => ({
        value: group.name,
        label: group.name,
    })) || [];
    const itemOptions = item_list.map(item => ({
        value: item.item_code,
        label: item.item_name,
    }));
    const supplierOptions = suppliersData?.data?.map(item => ({
        value: item.name,
        label: item.name,
    })) || [];


    const getItemdata = async (newOffset = 0, searchText = "") => {
        const res = await getitem_list_data({ start: newOffset, search_input: searchText });
        const products = res?.data?.result?.products || [];
        if (newOffset === 0) {
            setitem_list(products);
        } else {
            setitem_list((prev) => [...prev, ...products]);
        }
    };

    useEffect(() => {
        getItemdata();
    }, [triger]);



    const getDefaultDate = (daysOffset = 0) => {
        const date = new Date();
        date.setDate(date.getDate() + daysOffset);
        return date.toISOString().split('T')[0];
    };

    const [currentFilters, setCurrentFilters] = useState({
        company: 'Stackerbee',
        from_date: getDefaultDate(-30),
        to_date: getDefaultDate(0),
    });

    const getCleanedFilters = () => {
        const cleaned = { ...currentFilters };

        Object.keys(cleaned).forEach(key => {
            if (cleaned[key] === '') {
                delete cleaned[key];
            }
        });

        if (cleaned.status) {
            if (!Array.isArray(cleaned.status)) {
                cleaned.status = [cleaned.status];
            }
        } else {
            cleaned.status = [];
        }

        cleaned.start = (currentPage - 1) * pageSize;
        cleaned.page_length = pageSize;

        return cleaned;
    };

    const { data, error, isLoading, refetch } = useGetFrappeReportQuery({
        report_name: 'Item-wise Purchase History',
        filters: getCleanedFilters()
    });

    useEffect(() => {
        if (error?.data?.exception) {
            setShowError(true)
            setError(error.data.exception)
            setptype('Error')
            console.error('Frappe Report Error:', error.data.exception);
        }
    }, [error]);

    useEffect(() => {
        if (data?.message?.result) {
            const footer = data.message.result.find(item => Array.isArray(item));
            if (footer) {
                setTableFooter(["", ...footer]);
            } else {
                setTableFooter(null);
            }
        } else {
            setTableFooter(null);
        }
    }, [data?.message?.result]);



    const handleSaveColumns = (updatedColumns) => {
        setShowColumnConfig(false);
    };

    const filtersConfig = [
        {
            name: 'company',
            label: 'Company',
            width: '15%',
            type: 'selectsearch',
            options: companyOptions,
            defaultValue: 'Stackerbee'
        },
        { name: 'from_date', label: 'From Date', type: 'date', width: '12.3%', defaultValue: getDefaultDate(-30) },
        { name: 'to_date', label: 'To Date', type: 'date', width: '13.3%', defaultValue: getDefaultDate(0) },

        {
            name: 'item_code',
            label: 'Item',
            width: '18%',
            type: 'selectsearch',
            options: itemOptions
        },
        {
            name: 'item_group',
            label: 'Item Group',
            width: '18%',
            type: 'selectsearch',
            options: itemGroupOptions
        },
        {
            name: 'supplier',
            label: 'Supplier',
            width: '18%',
            type: 'selectsearch',
            options: supplierOptions
        },


    ];

    const handleFilterNewChange = (newFilters) => {
        setCurrentFilters(prev => ({
            ...prev,
            ...newFilters
        }));
        setCurrentPage(1);
    };

    const handleSearchChange = (name, value) => {
        console.log(`Search in ${name}:`, value);
        if (name === "item_code") {
            getItemdata(0, value);
        }
        if (name === "item_group") {
            setItemGroupSearchTerm(value);
        }
        if (name === "supplier") {
            setsupplierSearchTerm(value);
        }
        settriger(prev => !prev);

        refetch()

    };

    const handleView = (id) => {
        navigate(`/outbound/outbound-sales-order-view/`, { state: { salesorder: id } });
    };

    const handleEdit = (id) => {
        navigate(`/outbound/outbound-sales-order-edit/`, { state: { salesorder: id } });
    };

    const handleDelete = (id) => {
        console.log("Delete logic for ID:", id);
    };

    const getColumnWidth = (fieldname) => {
        switch (fieldname) {
            case 'date': return '200px';
            case 'quantity': return '100px';
            case 'uom': return '100px';
            case 'Date': return '80px';
            case 'amount': return '100px';
            case 'rate': return '100px';





            default: return '150px';
        }
    };

    const isSortable = (fieldname) => {
        const sortableFields = [
            'created_at',
            'updated_at',
            'project',
            'company'
        ];
        return sortableFields.includes(fieldname);
    };

    const getSortFn = (fieldtype, fieldname) => {
        if (fieldtype === 'Datetime') {
            return (a, b) => new Date(a[fieldname]) - new Date(b[fieldname]);
        }
        if (['Float', 'Currency', 'Int'].includes(fieldtype)) {
            return (a, b) => parseFloat(a[fieldname]) - parseFloat(b[fieldname]);
        }
        return undefined;
    };

    const excludedFields = [
        'batch_no',
    ];
    const preferredOrder = [
        'warehouse', 'item_code', 'item_name'
    ];

    const dynamicColumns = useMemo(() => {
        if (!data?.message?.columns) return [];

        const sortedColumns = [...data.message.columns]
            .filter(col => !excludedFields.includes(col.fieldname))
            .sort((a, b) => {
                const indexA = preferredOrder.indexOf(a.fieldname);
                const indexB = preferredOrder.indexOf(b.fieldname);

                if (indexA === -1 && indexB === -1) return 0;
                if (indexA === -1) return 1;
                if (indexB === -1) return -1;
                return indexA - indexB;
            });

        const baseColumns = sortedColumns.map(col => ({
            header: col.label,
            name: col.fieldname,
            accessor: col.fieldname,
            width: getColumnWidth(col.fieldname),
            sortable: isSortable(col.fieldname),
            sortFn: getSortFn(col.fieldtype, col.fieldname),
            fieldtype: col.fieldtype,
            options: col.options
        }));

        const siNoColumn = {
            header: 'SI No',
            name: 'si_no',
            width: '60px',
            sortable: false,
            cellRenderer: (row, rowIndex) => rowIndex + 1,
        };

        return [siNoColumn, ...baseColumns];
    }, [data, currentPage]);

    const actionButtons = [
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel"
        }
    ];

    // Filter out the footer data from the main data
    const tableData = useMemo(() => {
        if (!data?.message?.result) return [];
        return data.message.result.filter(item => !Array.isArray(item));
    }, [data]);
    console.log(tableFooter, "tableFooter_check");

    return (
        <div className="container-fluid mt-3">
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Report" },
                    { label: "Purchase Report" },

                    { label: "Item wise Purchase History",style:{color:'#270B79'} }
                ]}
                actionButtons={actionButtons}
            >
                <ReportSearchFilter
                    filtersConfig={filtersConfig}
                    onFilterChange={handleFilterNewChange}
                    onSearchChange={handleSearchChange}
                />

                <ReportTable
                    columns={dynamicColumns}
                    data={tableData}
                    loading={isLoading}
                      pageSize={pageSize}
                    totalRecords={data?.message?.total}
                    currentPage={currentPage}
                    onPageChange={setCurrentPage}
                    showPagination={true}
                    footer={tableFooter}
                />
            </ListLayout>

            <ConfigureColumns
                show={showColumnConfig}
                onClose={() => setShowColumnConfig(false)}
                onSave={handleSaveColumns}
                initialFields={dynamicColumns}
            />
            <ApiResponseBox
                poptype={ptype}
                show={showError}
                errorMessage={errorr}
                onClose={() => setShowError(false)}
            />
        </div>
    );
};

export default Lpntable;